(function () {
  var mainSwiper = null;
  var thumbsSwiper = null;
  var inited = false;

  function isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function pauseAllVideos(scope) {
    var videos = (scope || document).querySelectorAll('.product-media-slider video');
    videos.forEach(function(v){ try { v.pause(); } catch(e){} });
  }

  function initSlider() {
    if (inited || !document.querySelector('.product-media-slider')) return;
    inited = true;

    // Afficher l’indice "Glisser →" sur mobile
    var hint = document.querySelector('.swipe-hint');
    if (hint && isMobile()) hint.style.display = 'inline-flex';

    thumbsSwiper = new Swiper('.product-thumbs', {
      spaceBetween: 8,
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      slideToClickedSlide: true,
    });

    mainSwiper = new Swiper('.product-media-slider', {
      spaceBetween: 10,
      loop: false,
      navigation: {
        nextEl: '.product-media-slider .swiper-button-next',
        prevEl: '.product-media-slider .swiper-button-prev',
      },
      pagination: {
        el: '.product-media-slider .swiper-pagination',
        clickable: true,
      },
      keyboard: { enabled: true },
      thumbs: { swiper: thumbsSwiper },
      on: {
        slideChange: function () {
          pauseAllVideos();
        }
      }
    });
  }

  function destroySlider() {
    if (mainSwiper) { mainSwiper.destroy(true, true); mainSwiper = null; }
    if (thumbsSwiper) { thumbsSwiper.destroy(true, true); thumbsSwiper = null; }
    inited = false;
    // Masquer l’indice si présent
    var hint = document.querySelector('.swipe-hint');
    if (hint) hint.style.display = 'none';
  }

  function handleMode() {
    if (isMobile()) {
      if (!inited) initSlider();
    } else {
      if (inited) destroySlider();
      // Pause toutes vidéos quand on repasse desktop
      pauseAllVideos();
    }
  }

  document.addEventListener('DOMContentLoaded', handleMode);
  window.addEventListener('resize', handleMode);
})();
